import { FC, useEffect, useState } from 'react';

import { ShieldAlert } from 'lucide-react';

import { Button } from '../ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/Dialog';

export type BlockedAccount = {
    message: string;
    reason?: string | null;
};

type Props = {
    readonly blockedAccount?: BlockedAccount | null;
};

export const BlockedAccountDialog: FC<Props> = ({ blockedAccount }) => {
    const [open, setOpen] = useState(Boolean(blockedAccount));

    useEffect(() => {
        setOpen(Boolean(blockedAccount));
    }, [blockedAccount]);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="w-[calc(100%-2rem)] border-border sm:max-w-md dark:border-white/10 dark:bg-[#111827] dark:shadow-2xl">
                <DialogHeader className="items-center text-center sm:text-center">
                    <div className="mb-2 flex size-12 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-950/50 dark:text-red-400">
                        <ShieldAlert className="size-6" aria-hidden="true" />
                    </div>
                    <DialogTitle className="text-xl dark:text-slate-100">
                        Обліковий запис заблоковано
                    </DialogTitle>
                    <DialogDescription className="max-w-sm text-center leading-6 dark:text-slate-400">
                        {blockedAccount?.message}
                    </DialogDescription>
                </DialogHeader>

                {blockedAccount?.reason && (
                    <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 dark:border-red-900/70 dark:bg-red-950/30">
                        <p className="text-xs font-semibold tracking-wide text-red-700 uppercase dark:text-red-300">
                            Причина блокування
                        </p>
                        <p className="mt-1 text-sm leading-6 text-red-950 dark:text-red-100">
                            {blockedAccount.reason}
                        </p>
                    </div>
                )}

                <DialogFooter>
                    <Button className="w-full" onClick={() => setOpen(false)}>
                        Зрозуміло
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
